// src/pages/dashboard/LivePerformance.jsx
import React from 'react';

const LivePerformance = () => {
  return (
    <div className="bg-[#0B3A32] p-6 rounded-xl shadow-lg">
      <h2 className="text-xl font-semibold text-[#CE9242] mb-2">📈 Live Performance</h2>
      <p className="text-sm text-gray-300 mb-4">
        Real-time tracking of your trading bot’s performance including P&L, win rate, and order success.
      </p>

      {/* Placeholder for performance metrics */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-[#062925] p-4 rounded-md">
          <p className="text-gray-400 text-sm">Today's Profit</p>
          <p className="text-lg font-bold text-white">+$52.10</p>
        </div>
        <div className="bg-[#062925] p-4 rounded-md">
          <p className="text-gray-400 text-sm">Total Trades</p>
          <p className="text-lg font-bold text-white">93</p>
        </div>
        <div className="bg-[#062925] p-4 rounded-md">
          <p className="text-gray-400 text-sm">Win Rate</p>
          <p className="text-lg font-bold text-white">78%</p>
        </div>
      </div>
    </div>
  );
};

export default LivePerformance;
